<!-- <div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create Emergency Info</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Create Emergency Info</h2>
    </div>

    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div class="row row-gap-4" formArrayName="emergencyInfoNotes">
            <div class="col-12 col-lg-8">
                <div class="bg-lighter border border-light rounded p-3 p-md-4 mb-3 mb-md-4 position-relative"
                    *ngFor="let item of emergencyInfoNotes().controls; let i=index" [formGroupName]="i">
                    <div class="d-flex flex-column row-gap-4">
                        <div class="d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Add Title"
                                    formControlName="headline" maxlength="200">
                                <label>Add Title</label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="emergencyInfoNotes().controls[i].get('headline').invalid && emergencyInfoNotes().controls[i].get('headline').touched"
                                    class="small text-danger">
                                    <div *ngIf="emergencyInfoNotes().controls[i].get('headline').errors?.required">
                                        Headline is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <textarea class="form-control" placeholder="Add Text" formControlName="description"
                                    maxlength="1000"></textarea>
                                <label>Add Description</label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="emergencyInfoNotes().controls[i].get('description').invalid && emergencyInfoNotes().controls[i].get('description').touched"
                                    class="small text-danger">
                                    <div *ngIf="emergencyInfoNotes().controls[i].get('description').errors?.required">
                                        Description is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <input onclick="this.value = null" formControlName="emergencyInfoPhotos" id="emergencyInfoPhotos" type="file"
                            accept=".png, .jpg, .jpeg" (change)="onFileChange($event)" />
                        <div class="d-flex flex-column row-gap-3">
                            <div class="d-flex align-items-center justify-content-between upload_field"
                                (click)="uploadImages.click()">
                                <span class="text-truncate mr-3">{{imageName ? imageName : 'Upload Image'}}</span>
                                <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                            </div>
                            <input onclick="this.value = null" formControlName="emergencyInfoPhotos"
                                id="emergencyInfoPhotos" type="file" class="d-none" accept=".png, .jpg, .jpeg"
                                (change)="onFileChange($event)" #uploadImages>
                        </div>
                        <div *ngIf="images.length">
                            <div class="row row-gap-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                    *ngFor='let image of images; let j = index;'>
                                    <div class="uploaded_images">
                                        <img [src]="image.imgBase64">
                                        <span class="remove_icon" (click)="removeImage(j)">
                                            <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                        <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
        </div>

        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
</div> -->


<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create Emergency Info</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Create Emergency Info</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div class="row row-gap-4" formArrayName="emergencyInfoRequest">
            <div class="col-12 col-lg-8" *ngFor="let item of emergencyInfoRequest().controls; let i=index"
                [formGroupName]="i">
                <div class="bg-lighter border border-light rounded p-3 p-md-4 mb-3 mb-md-4 position-relative">
                    <div class="d-flex flex-column row-gap-4">
                        <div class="d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Add Title" formControlName="header"
                                    maxlength="200">
                                <label>Add Title</label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="item.get('header').invalid && item.get('header').touched"
                                    class="small text-danger">
                                    <div *ngIf="item.get('header').errors?.required">
                                        Headline is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <!-- <textarea class="form-control" placeholder="Add Text" formControlName="description"
                                    maxlength="1000"></textarea> -->
                                <!-- <label>Add Description</label> -->
                                <ckeditor [editor]="Editor" [config]="ckconfig" formControlName="description"></ckeditor>
                                <!-- <label>Add Description</label> -->
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="item.get('description').invalid && item.get('description').touched"
                                    class="small text-danger">
                                    <div *ngIf="item.get('description').errors?.required">
                                        Description is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column row-gap-3">
                            <div class="d-flex align-items-center justify-content-between upload_field"
                                (click)="triggerFileInputClick(uploadImage)">
                                <span class="text-truncate mr-3">{{imageNames[i] ? imageNames[i] : 'Upload
                                    Image'}}</span>
                                <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                            </div>
                            <input type="file" class="d-none" accept=".png, .jpg, .jpeg"
                                (change)="onFileChange($event, i)" #uploadImage>
                        </div>
                        
                        <div *ngIf="images[i]?.length">
                            <div class="row row-gap-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                    *ngFor='let image of images[i]; let j = index;'>
                                    <div class="uploaded_images">
                                        <img [src]="image.imgBase64">
                                        <span class="remove_icon" (click)="removeImage(i, j)">
                                            <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                        <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
        </div>

        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>